

export const getBuildersMenuItems = (callback) => {
    let items = [
        {
            title: 'Block',
            description: "Create a block portfolio. You will most likely never need a block, but if you do, it's here. They can only hold securities.",
            onClick: () => { callback('b'); },
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/portfolioGraphics/white-block.jpeg',
            type: 'b'
        },
        {
            title: 'Sleeve',
            onClick: () => { callback('s'); },
            description: "Sleeves allow for more granular 'sleeving' of your portfolio. They excel for managers wanting to compartmentalize their portfolios beyond equity/fixed income.",
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/portfolioGraphics/white-pillar.jpeg',
            type: 's'
        },
        {
            title: 'Model',
            description: "Models are the most common portfolio type. They allow for the creation of a model portfolio that can be applied to multiple clients.",
            onClick: () => { callback('m'); },
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/builder-icons/sleeve-portfolio-shapes.jpeg',
            type: 'm'
        },
        {
            title: 'Model of Models',
            description: "Create a personalized client portfolio streamlined through your existing models and sleeves",
            onClick: () => { callback('mm'); },
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/portfolioGraphics/upload-files.jpeg',
            type: 'mm'
        },
    ];
    items.reverse();
    return items;
};
